<template>
  <v-container fluid>
    <ul
      style="
        position: fixed;
        z-index: 3;
        right: 35px;
        bottom: 30px;
        list-style: none;
      "
    >
      <li v-for="(alertItem, i) in $store.state.alertItems" :key="i">
        <v-alert :type="alertItem.type" style="width: 415px">
          {{ alertItem.text }}
          <img
            :src="alertItem.image"
            style="
              height: 56px;
              position: absolute;
              top: 0px;
              right: 5px;
              border-radius: 5px;
            "
          />
        </v-alert>
      </li>
    </ul>
    <crud-data-table
      v-if="!loading"
      :headers="tableSchema"
      :tableConfig="tableConfig"
      :tableData="tableData"
      @addNewItemClick="addNewItemHandler"
      @editItemClick="editItemHandler"
      @removeItemClick="removeItemClick"
      @updateSelectedRows="updateSelectedRows"
    />

    <edit-item-dialog
      v-if="!loading"
      :type="dialogType"
      :isActive="isDialogActive"
      :dataObject="editingObject"
      :tableSchema="tableSchema"
      :tableConfig="tableConfig"
      @closeEditDialog="closeEditDialogHandler"
      @saveChangesHandler="saveChangesHandler"
    />

    <removeItemDialog
      :isActive="isRemoveDialogActive"
      @closeRemoveItemDialog="isRemoveDialogActive = false"
      @removeItem="removeItemHandler"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import EditItemDialog from "@/components/editItemDialog/EditItemDialog";
import CrudDataTable from "@/components/CrudDataTable";
import RemoveItemDialog from "@/components/removeItemDialog/RemoveItemDialog";

import { TABLE_CONFIG, DIALOG_TYPES } from "@/constants/common";
import {
  LOAD_TABLE,
  POST_CREATE_NEW_ITEM,
  POST_UPDATE_ITEM,
  POST_DELETE_ITEM,
} from "@/store/actions.type.js";
import { SET_TABLE_ENTITY } from "@/store/mutations.type.js";
import { v4 as uuid } from "uuid";

export default {
  components: { CrudDataTable, EditItemDialog, RemoveItemDialog },
  props: {
    entityType: String,
  },

  data() {
    return {
      isDialogActive: false,
      isRemoveDialogActive: false,
      dialogType: null,
      editingObject: null,
      editingObjectCp: null,
      tableConfig: null,
      itemToDelete: null,

      imageData: null,
      tableSelectedRows: [],
      listnerStatus: false,
    };
  },

  computed: {
    ...mapState({
      tableData: (s) => s.tables.tableData,
      tableSchema: (s) => s.tables.tableSchema,
      tableEntityType: (s) => s.tables.tableEntityType,
      loading: (s) => s.tables.loading,
      error: (s) => s.tables.error,
    }),
  },

  async created() {
    this.$store.commit(SET_TABLE_ENTITY, this.entityType);
    this.tableConfig = TABLE_CONFIG[this.tableEntityType];

    this.$store.dispatch(LOAD_TABLE);

    if (!this.listnerStatus) {
      window.addEventListener("paste", this.quickInsertPasteHandler);
    }
  },

  beforeDestroy() {
    this.listnerStatus = false;
    window.removeEventListener("paste", this.quickInsertPasteHandler);
  },

  methods: {
    addNewItemHandler() {
      this.dialogType = DIALOG_TYPES.CREATE;
      this.isDialogActive = true;
    },

    editItemHandler(item) {
      this.dialogType = DIALOG_TYPES.EDIT;
      this.editingObject = item;
      this.isDialogActive = true;
    },

    removeItemClick(payload) {
      this.itemToRemove = payload;
      this.isRemoveDialogActive = true;
    },

    removeItemHandler() {
      this.$store.dispatch(POST_DELETE_ITEM, this.itemToRemove);
      this.isRemoveDialogActive = false;
    },

    resetEditableFields() {
      this.editingObject = this.editingObjectCp;
    },

    closeEditDialogHandler() {
      this.isDialogActive = false;
    },

    saveChangesHandler({ editType, data }) {
      if (editType === DIALOG_TYPES.CREATE) {
        this.$store.dispatch(POST_CREATE_NEW_ITEM, data);
        this.isDialogActive = false;
      }

      if (editType === DIALOG_TYPES.EDIT) {
        this.$store.dispatch(POST_UPDATE_ITEM, data);
        this.isDialogActive = false;
      }
    },

    updateSelectedRows(rows) {
      this.tableSelectedRows = rows;
    },

    quickInsertPasteHandler(e) {
      this.listnerStatus = true;
      if (this.isDialogActive || !this.$store.state.quickInsertEnabled) return;

      const file = e.clipboardData.files[0];

      if (!file || !file.type.startsWith("image/")) {
        return;
      }
      const reader = new FileReader();

      reader.onload = async (e) => {
        this.imageData = e.target.result;

        let fileBase64 = await fetch(this.imageData);
        let blob = await fileBase64.blob();
        let fileName = [uuid(), "jpg"].join(".");
        let packedFile = new File([blob], fileName, { type: "image/jpg" });

        let selectedTheme = this.tableSelectedRows[0];
        this.$store.dispatch(POST_CREATE_NEW_ITEM, {
          file: packedFile,
          entity: "templates",
          themes_id: selectedTheme ? selectedTheme.id : 0,
          publish: false,
        });

        this.$store.dispatch("addAlertItem", {
          image: this.imageData,
          text: "Шаблон успешно создан",
          type: "success",
          id: fileName,
        });
      };

      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped>
.span {
  background: #93ff93;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 400px;
  /* border-radius: 10px; */
  font-weight: 500;
}
</style>
